// src/components/store/sections/newsletter/NewsletterV90OrigamiofferFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV90OrigamiofferFuchsiaGlow(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={90}
      archKey="origami_offer"
      archLabel="Origami Ribbon Offer"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
